(function($){

	/**
	 *  Función que inicializa la función principal del Bloque Gutenberg: initSlider
	 * 	@param block - pasado por referencia en la parte privada; como elemento HTML en la pública
	 */
	var initializeBlock = function( block ) {

		if(block.hasClass('acf-block-preview')){
			block = block.find('.lnm-slider');
		}

    	let slider = block.find('.owl-carousel');
    	initSlider(block, slider);
    }

    /**
     * Disparador. Llama a la función "inicializadora" desde la parte pública
     * Modificar el selector de elemento $(elemento) para adaptarlo a lo que necesitemos
     */
    // $(document).ready(function(){
    //     $('.bargut-slider').each(function(){
    //         initializeBlock( $(this) );
    //     });
    // });

    /**
     * Disparador. Llama a la función "inicializadora" desde la parte privada
     * Modifficar el parámetro type de la acción render_block_preview.
     * En este caso se llama a type=slider, siendo slider el nombre de la carpeta que contiene el bloque
     */ 
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=slider-post-type', initializeBlock );
        window.acf.addAction( 'render_block_preview/type=slider-featured', initializeBlock );
        window.acf.addAction( 'render_block_preview/type=slider-testimonial', initializeBlock );
        window.acf.addAction( 'render_block_preview/type=community', initializeBlock );
    }


    /**
     * Función que ejecuta el javascript que queremos asociar a nuestro bloque
     * Es llamada desde la función "inicializadora" initializeBlock.
     */
	function initSlider(block, slider){

		const arrows = slider.closest('.lnm-slider').find('.lnm-slider__arrows');
		const arrowNext = slider.closest('.lnm-slider').find('.lnm-slider__arrow--next');
		const arrowPrev = slider.closest('.lnm-slider').find('.lnm-slider__arrow--prev');

		const dotsNav = slider.closest('.lnm-slider').find('.lnm-slider__dots-container');
		const dots = slider.closest('.lnm-slider').find('.lnm-slider__dot');

		let options = get_slider_options(block);
		slider.owlCarousel(options);


		// Si hay flechas
		if(arrowNext || arrowPrev){

			arrowNext.on('click',function(e){
				e.preventDefault();
				slider.trigger('next.owl.carousel');
			});

			arrowPrev.on('click',function(e){
				e.preventDefault();
				slider.trigger('prev.owl.carousel');
			});

		}

		// Si hay dots
		if(dots.length > 0){
			dots.click(function(e){
				e.preventDefault();
				dots.removeClass('active');

				let dotsGroup = jQuery(this).closest('.lnm-slider__dots-container').find('.lnm-slider__dot');

				let nr = dotsGroup.index( jQuery(this) );

				dotsNav.each(function(){
					jQuery('.lnm-slider__dot',this).eq(nr).addClass('active');
				});

				slider.trigger('to.owl.carousel', [jQuery(this).index(), 300]);
			})
		}


		/**
		 * Calcula el número de diapositiva y deshabilita la flecha correspondiente en caso de ser necesario.
		 * También comprueba si es neceario cambiar los captions (subtítulo) de la cabecera
		 */
		function afterSlideChange(event){

			//let slider    = event.target;		  // Slider owl-carousel
			let items     = event.item.count;     // Number of items
		    let item      = event.item.index;     // Position of the current item
		    let size      = event.page.size;      // Number of items per page
		    let pages     = event.page.count;	  // Número de páginas
		    
		    // Si solo hay una página, ocultamos las flechas
		    if(items === size || items <= size ){
		    	arrows.addClass('lnm-slider__arrows--disabled');
		    }else{
		    	arrows.removeClass('lnm-slider__arrows--disabled');
		    }


		    if (item === 0) {
		        arrowPrev.addClass('lnm-slider__arrow--is-disabled');
		        arrowNext.removeClass('lnm-slider__arrow--is-disabled');
		    }else if ((items - item) === size) {
		        arrowPrev.removeClass('lnm-slider__arrow--is-disabled')
		        arrowNext.addClass('lnm-slider__arrow--is-disabled');
		    }else{
		    	arrowNext.removeClass('lnm-slider__arrow--is-disabled');
				arrowPrev.removeClass('lnm-slider__arrow--is-disabled')
		    }

		    if( $(slider).closest('.lnm-slider').hasClass('lnm-slider--with-captions') ){
		    	changeCaption(event);
		    }
		}


		/**
		 * Si el slide tiene un atributo data, copia el texto y sustituye el subtítulo del header
		 */
		function changeCaption(event){

			let slideNr = event.item.index + 1;
			let slider = $( event.target );

			let slide = slider.find( '.owl-item:nth-of-type('+ slideNr  +') .lnm-slider__slide' );
			
			let caption = slide.attr('data-lnm-slide-title')
			let subtitle = slider.closest('.lnm-slider').find('.lnm-slider__subtitle');

			subtitle.text(caption);
		}


		/**
		 * Establece una altura fija para que el slider no provoque cambios de altura en el dom
		 */

		function setSliderHeight(){

			let element = block.find('.owl-item');

			setTimeout(function () {
		        let height = element.outerHeight();

		        if(height == 0){
		        	setSliderHeight( );
		        	return;
		        }

		        slider.outerHeight( element.outerHeight() );
		        block.css({
		        	visibility : 'visible',
		        	height : 'auto'
		        });

		    }, 500);

		    
			$(window).on('resize', function(){
		    	setSliderHeight( )
		    });	
		}


		function get_slider_options(block){

			let args = null;

			if( block.hasClass('barcpt-place-gallery') ){
				
				args = {
					loop: true,
					items: 1,
					dots: false,
					nav: false,
					margin: 0,
					stagePadding: 250,
					center: true,
					responsiveClass:true,
					autoHeight: false,
					smartSpeed: 500,
					onInitialized: setSliderHeight,
					responsive : {
						0: {
							items: 1,
							stagePadding: 0,
						},
						768: {
							items: 1,
							stagePadding: 175,
						},
						960: {
							items: 1,
							stagePadding: 250,
						},
						1128: {
							items: 1,
							stagePadding: 300,
						}
					}
				}

			}else if( block.hasClass('lnm-slider-featured') ){
				
				args = {
					items: 1,
					dots: false,
					nav: false,
					margin: 0,
					stagePadding: 0,
					autoHeight: true,
				}

				
			}else if( block.hasClass('lnm-slider-testimonial') ){

				args = {
					loop: false,
					dots: false,
					stagePadding: 0,
					autoHeight: true,
					responsive:{
				        0:{
				            items:1
				        },
				    },
				    onChanged: afterSlideChange,
				}

			}else if(block.hasClass('lnm-slider--with-captions')){

				args = {
					loop: false,
					items: 1,
					dots: false,
					nav: false,
					margin: 0,
					stagePadding: 0,
					onChanged: afterSlideChange,
				}
			}else if( block.hasClass('lnm-slider--community') ){


				if(block.hasClass('lnm-slider--community-cards')){
					args = {
						loop: false,
						stagePadding: 0,
						margin: 16,
						responsive:{
					        0:{
					            items:1
					        },
					        600: {
					        	items:2,
					        	margin: 24,
					        },
					        800:{
					            items:3,
					        },
					        1128:{
					            items:4,
					        },
					    },
					    onChanged: afterSlideChange,
					    // onInitialized: checkNumberItems
					} // Fin args
				}else{

					args = {
						loop: false,
						stagePadding: 0,
						responsive:{
					        0:{
					            items: 2,
					            margin: 16,
					        },
					        500: {
					        	items: 3,
					        	margin: 24,
					        },
					        700: {
					        	items: 4,
					        	margin: 32,
					        },
					        960:{
					            items:5,
					            margin: 48,
					        },
					        1128:{
					            items:6,
					            margin: 52
					        },
					    },
					    onChanged: afterSlideChange,
					    // onInitialized: checkNumberItems
					} // Fin args

				}
			}else if(block.hasClass('lnm-slider--vacancy')){
				args = {
					items: 1,
					dots: false,
					nav: false,
					margin: 0,
					responsive : {
						0: {
							items: 1,
						},
						768: {
							items: 2,
						},
						960: {
							items: 3,
						}
					},
					onChanged: afterSlideChange,
				}
			}else if(block.hasClass('lnm-slider--related-barcpt-program')){
				args = {
					items: 1,
					dots: false,
					nav: false,
					margin: 0,
					onChanged: afterSlideChange,
				}
			}else if(block.hasClass('lnm-slider--related')){
				args = {
					items: 1,
					dots: false,
					nav: false,
					margin: 16,
					responsive : {
						0: {
							items: 1,
						},
						768: {
							items: 2,
							margin: 24
						},
						960: {
							items: 3,
							margin: 48
						},
						1080: {
							items: 3,
							margin: 62
						},

					},
					onChanged: afterSlideChange,
				}
			}

			return args;
		}
	}


})(jQuery)